import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenantCertificationComponent } from './tenant-certification.component';
import {ToolbarModule} from 'src/app/layout/toolbar/toolbar.module';
import {IconsModule} from '../../icons/icons.module';
import {SharedModule} from 'src/app/shared/shared.module';
import { TableModule } from 'src/app/table/table.module';
import { LeftSideNavigationModule } from 'src/app/layout/left-side-navigation/left-side-navigation.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCardModule} from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import {DefaultFilterModule} from '../../components/default-filter/default-filter.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TenantCertificationRoutingModule } from './tenant-certification-routing.module';
import { TenantCertificationDetailsModule } from '../tenant-certification-details/tenant-certification-details.module';


@NgModule({
  declarations: [TenantCertificationComponent],
  imports: [
    CommonModule,
    ToolbarModule,
    IconsModule,
    SharedModule,
    TableModule,
    LeftSideNavigationModule,
    MatProgressSpinnerModule,
    SidenavHeaderModule,
    MatDividerModule,
    MatTabsModule,
    MatExpansionModule,
    MatCardModule,
    MatSelectModule,
    DefaultFilterModule,
    MatProgressBarModule,
    TenantCertificationRoutingModule,
    TenantCertificationDetailsModule
  ],
  exports: [
    TenantCertificationComponent
  ]
})
export class TenantCertificationModule { }